<template>
    <v-container grid-list-xl fluid>
        <v-layout>
            <v-flex>
                <h3 class="pr-3">{{ $t('menu.home') }}</h3>
            </v-flex>
        </v-layout>
        <div class="text-xs-center">
            <v-progress-circular
              :rotate="360"
              :size="100"
              :width="15"
              :value="value"
              color="teal"
            >
                {{ value }}
            </v-progress-circular>

            <v-progress-circular
              :rotate="-90"
              :size="100"
              :width="15"
              :value="value"
              color="primary"
            >
                {{ value }}
            </v-progress-circular>
        </div>
        <div class="text-xs-center">
            <v-progress-circular
              :rotate="90"
              :size="100"
              :width="15"
              :value="value"
              color="red"
            >
                {{ value }}
            </v-progress-circular>

            <v-progress-circular
              :rotate="180"
              :size="100"
              :width="15"
              :value="value"
              color="pink"
            >
                {{ value }}
            </v-progress-circular>
        </div>
    </v-container>
</template>

<script>
  export default {
    data () {
      return {
        //interval: {},
        value: 50
      }
    },
    beforeDestroy () {
      //clearInterval(this.interval)
    },
    mounted () {
      // this.interval = setInterval(() => {
      //   if (this.value === 100) {
      //     return (this.value = 0)
      //   }
      //   this.value += 10
      // }, 1000)
    }
  }
</script>

<style lang="stylus" scoped>
    .v-progress-circular
        margin: 1rem
</style>